import { registerPlugin, mergeConfig } from '@modern-js/runtime/plugin';
import { getGlobalAppConfig, getGlobalLayoutApp } from '@modern-js/runtime/context';
import runtimeConfig from '@_modern_js_src/modern.runtime';

const plugins = [];

import { routerPlugin } from '@modern-js/runtime/router';

plugins.push(routerPlugin(mergeConfig({"serverBase":["/"]}, (runtimeConfig || {})['router'], ((runtimeConfig || {})['routerByEntries'] || {})['main'], (getGlobalAppConfig() || {})['router'])));

registerPlugin(plugins, runtimeConfig);
